/*
    Create by fanglijuan 2016-05-10
*/
'use strict';
angular.module("importUserModule", [])
    .controller("importUserCtrl", ["$scope", "$q", "$timeout", "$validation", "trsHttpService", '$http', '$modalInstance', "userManageMentService", "trsspliceString", "importUserInfo", "modalDialog", "Upload", function($scope, $q, $timeout, $validation, trsHttpService, $http, $modalInstance, userManageMentService, trsspliceString, importUserInfo, modalDialog, Upload) {
        initStatus();
        /**
         * [initStatus description]初始化参数
         */
        function initStatus() {
            $scope.data = {
                modalTitle: importUserInfo.modalTitle,
                groupId: importUserInfo.groupId,
                fileName: ""
            };
            $scope.file = {
                name: ""
            };
            $scope.params = {
                "name": ""
            };
        }



        /**
         * [chooseFile description] 选择其中文件变化
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        $scope.chooseFile = function(event) {
            var target = event.target;
            if (target.tagName === "INPUT" && target.files[0].$error === 'pattern') {
                modalDialog.alertType("请按要求选择需要上传的文件", "", "warning", "confirm");
            }
        };
        //确定
        $scope.confirm = function() {
            Upload.upload({
                url: '/wcm/openapi/uploadFile',
                data: {
                    file: $scope.file
                }
            }).then(function(resp) {
                var params = $scope.data.groupId === "" ? {
                    serviceid: "mlf_usermanagement",
                    methodname: "importNewUsers",
                    ImportUsersFile: resp.data.imgName
                } : {
                    serviceid: "mlf_usermanagement",
                    methodname: "importGroupUsers",
                    ImportGroupUsersFile: resp.data.imgName,
                    GroupId: $scope.data.groupId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get", true).then(function(data) {
                    errorReport(data);
                    $modalInstance.close(params);
                }, function(data) {
                    if (data.code == "5000") {
                        modalDialog.alertType("导入的文件不是正确的excel文件格式，请重新导入", "", "error", "confirm");
                    }
                    if (data.status == "-1") {
                        modalDialog.alertType(data.message, data.detail, "error", 'confirm')
                    }
                });
            });
        };
        /**
         * [errorReport description] 错误信息处理
         * @param {object} [data] [description] 错误数据
         * @return {[type]} [description]
         */
        function errorReport(data) {
            var deffer = $q.defer();
            if (data.length == 1 && data[0].VALUE == "传入的excel文件内容为空") {
                modalDialog.alertType("EXCEL内容为空，请填写EXCEL后重新上传", "", "warning", "confirm");
            } else if (data.length == 1 && data[0].LOSEROW == "0") {
                var successInfo = data[0].SUCESSROW + "条数据全部上传成功";
                modalDialog.alertType(successInfo, "", "success", "confirm");
            } else {
                userManageMentService.importTips(data);
            }
            return deffer.promise;
        }
        //取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

    }]);